module.exports = __webpack_public_path__ + "public/SideMenuIcons/tracking.svg?e71ecddd";